import { FC, memo } from 'react';
import cn from 'bem-cn';
import { FeedFormula } from '@ai-platform/utils';
import { Link, Stack } from '../../components/UI';
import { usePromptFeedColumns } from '../HomePage/HomePage.hooks';
import { Feed, FeedPlace, useInfiniteFeed } from '../../components/Feed';

import aliceLogo from '../PromoResearchPage/assets/alice-logo.svg';
import museumImage from './assets/museum-night.png';

import './PromoMuseumNightPage.scss';

const b = cn('promo-museum-night-page');

export const PromoMuseumNightPage: FC = memo(() => {
    const columns = usePromptFeedColumns();

    const {
        prompts,
        loading: isLoading,
        hasMore,
    } = useInfiniteFeed({
        threshold: 600,
        category: 'museumnight',
        formulaName: FeedFormula.PromoMuseumNight,
    });

    const aliceURL = 'https://alice.yandex.ru?from=prompthub&utm_source=prompthub&utm_medium=promo-museumnight';

    return (
        <div className={b()}>
            <Stack className={b('header')} direction="column" justifyContent="space-between">
                <div className={b('logo')}>
                    <Link external to={aliceURL}>
                        <img src={aliceLogo} className={b('logo', 'image')} alt="Alice AI" />
                    </Link>
                </div>

                <img className={b('header', 'image')} src={museumImage} alt="" />

                <Stack className={b('header', 'content')}>
                    <h1 className={b('title')}>Оживите искусство с&nbsp;Алисой&nbsp;AI</h1>
                    <p className={b('description')}>Подборка промптов для Ночи в&nbsp;Музее&nbsp;2026</p>
                </Stack>
            </Stack>
            <div className={b('content')}>
                <h3 className={b('feed-title')}>Примеры задач &mdash; попробуйте прямо&nbsp;сейчас</h3>
                <Feed
                    containerClassName={b('feed')}
                    prompts={prompts}
                    courses={[]}
                    challenges={[]}
                    columns={Math.min(columns, 4)}
                    isLoading={isLoading}
                    hasMore={hasMore}
                    needMarkPromptsAsViewed={false}
                    place={FeedPlace.PromoMuseumNight}
                />
            </div>
        </div>
    );
});
